import React, { FC, useMemo } from "react";
import clsx from "clsx";

import useFileTypeQualifier from "hooks/use-file-type-qualifier";

import VideoImage from "../../resources/images/video.png";
import Video360Image from "../../resources/images/video-360.png";
import { Item } from "../../models/item.type";
import noPreviewImage from "../../resources/images/noPreview.png";

import styles from "./file.module.css";

type FileProps = {
  file: Item;
  isSelect: boolean;
  onClick: () => void;
};

const File: FC<FileProps> = (props) => {
  const { file, isSelect, onClick } = props;
  const qualifier = useFileTypeQualifier();
  function handleOnError(event) {
    event.target.src = noPreviewImage;
  }

  const containerStyles = clsx(
    styles.container,
    isSelect && styles.containerSelected
  );

  const filePreview = useMemo(() => {
    if (qualifier.isVideo(file.file_link)) {
      if (file.file_link.includes(".360.")) {
        return Video360Image;
      } else {
        return VideoImage;
      }
    } else if (file.file_link) {
      return file.file_link;
    } else {
      return file.preview;
    }
  }, [file.file_link, file.preview, qualifier]);

  return (
    <div className={containerStyles} onClick={onClick}>
      <img
        onError={handleOnError}
        className={styles.image}
        src={filePreview}
        alt=""
      />
    </div>
  );
};

export default File;
